// API related actions
export const SUBMIT_EXECUTE_VEH_AUDI_REQUEST = '@@toyota/SUBMIT_EXECUTE_VEH_AUDI_REQUEST';
export const SUBMIT_EXECUTE_VEH_AUDI_SUCCESS = '@@toyota/SUBMIT_EXECUTE_VEH_AUDI_SUCCESS';
export const SUBMIT_EXECUTE_VEH_AUDI_FAILED = '@@toyota/SUBMIT_EXECUTE_VEH_AUDI_FAILED';
export const FETCHING_VEH_AUDI_REPORT = '@@toyota/FETCHING_VEH_AUDI_REPORT';
export const FETCHED_VEH_AUDI_REPORT = '@@toyota/FETCHED_VEH_AUDI_REPORT';
export const FETCHED_VEH_AUDI_REPORT_FAILED = '@@toyota/FETCHED_VEH_AUDI_REPORT_FAILED';
export const DELETE_VEH_AUDI_REPORT = '@@toyota/DELETE_VEH_AUDI_REPORT';
export const CHANGE_VEH_AUDI_REPORT_LIST_PAGE = '@@toyota/CHANGE_VEH_AUDI_REPORT_LIST_PAGE';
export const CHANGE_VEH_AUDI_REPORT_LIST_PAGE_SIZE = '@@toyota/CHANGE_VEH_AUDI_REPORT_LIST_PAGE_SIZE';
export const DOWNLOADING_VEH_AUDI_REPORT_LIST_FILE = '@@toyota/DOWNLOADING_VEH_AUDI_REPORT_LIST_FILE';
export const DOWNLOADED_VEH_AUDI_REPORT_LIST_FILE = '@@toyota/DOWNLOADED_VEH_AUDI_REPORT_LIST_FILE';
export const DOWNLOADED_VEH_AUDI_REPORT_LIST_FILE_FAILED = '@@toyota/DOWNLOADED_MONTH_CLOSE_REPORT_LIST_FILE_FAILED';
export const DELETE_URL_AUDI = '@@toyota/DELETE_URL_AUDI';
export const FETCHING_VEH_AUDI_SET_REPORT = '@@toyota/FETCHING_VEH_AUDI_SET_REPORT';
export const FETCHED_VEH_AUDI_SET_REPORT = '@@toyota/FETCHED_VEH_AUDI_SET_REPORT';
export const FETCHED_VEH_AUDI_SET_REPORT_FAILED = '@@toyota/FETCHED_VEH_AUDI_SET_REPORT_FAILED';
export const DOWNLOADING_VEH_AUDI_SET_REPORT_FILE = '@@toyota/DOWNLOADING_VEH_AUDI_SET_REPORT_FILE';
export const DOWNLOADED_VEH_AUDI_SET_REPORT_FILE = '@@toyota/DOWNLOADED_VEH_AUDI_SET_REPORT_FILE';
export const DOWNLOADED_VEH_AUDI_SET_REPORT_FILE_FAILED = '@@toyota/DOWNLOADED_VEH_AUDI_SET_REPORT_FILE_FAILED';
export const FETCHING_VEH_AUDI_INF = '@@toyota/FETCHING_VEH_AUDI_INF';
export const FETCHED_VEH_AUDI_INF = '@@toyota/FETCHED_VEH_AUDI_INF';
export const FETCHED_VEH_AUDI_INF_FAILED = '@@toyota/FETCHED_VEH_AUDI_INF_FAILED';
